import { Add } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { faqs } from "../../constants/faqs";

const FaqSection = () => {
  const [expanded, setExpanded] = useState(null);
  const navigate = useNavigate();

  const handleChange = (panel) => (_, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  return (
    <Box
      sx={{
        position: "relative",
        py: { xs: 8, md: 6 },
        overflow: "hidden",

        // 🔹 Subtle background pattern
        background: `
          radial-gradient(circle at 1px 1px, rgba(0,0,0,0.04) 1px, transparent 0)
        `,
        backgroundSize: "24px 24px",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 6, md: 10 }}>
          
          {/* LEFT CONTENT */}
          <Grid item xs={12} md={4}>
            <Typography variant="h3" color="primary" fontWeight={700} gutterBottom>
              Frequently Asked Questions
            </Typography>

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ lineHeight: 1.8 }}
            >
              Everything you need to know about MySchoolling —
              from platform features to onboarding and support.
            </Typography>
          </Grid>

          {/* RIGHT ACCORDIONS */}
          <Grid item xs={12} md={8}>
            {faqs.map((faq, index) => (
              <Accordion
                key={index}
                expanded={expanded === index}
                onChange={handleChange(index)}
                elevation={0}
                sx={{
                  mb: 2,
                  borderRadius: 3,
                  border: "1px solid rgba(0,0,0,0.06)",
                  backgroundColor: "#ffffff",
                  transition: "all 0.3s ease",

                  borderLeft:
                    expanded === index
                      ? "4px solid #1976d2"
                      : "4px solid transparent",

                  "&:hover": {
                    boxShadow: "0 12px 30px rgba(0,0,0,0.05)",
                  },

                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <Add
                      sx={{
                        transition: "transform 0.3s ease",
                        transform:
                          expanded === index
                            ? "rotate(45deg)"
                            : "rotate(0deg)",
                      }}
                    />
                  }
                  sx={{
                    px: 3,
                    py: 2.5,
                  }}
                >
                  <Typography variant="h6" fontWeight={600}>
                    {faq.question}
                  </Typography>
                </AccordionSummary>

                <AccordionDetails
                  sx={{
                    px: 3,
                    pb: 3,

                    // 🔹 Smooth animated expand
                    animation:
                      expanded === index
                        ? "fadeSlide 0.3s ease"
                        : "none",

                    "@keyframes fadeSlide": {
                      from: {
                        opacity: 0,
                        transform: "translateY(-5px)",
                      },
                      to: {
                        opacity: 1,
                        transform: "translateY(0)",
                      },
                    },
                  }}
                >
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ lineHeight: 1.8 }}
                  >
                    {faq.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}

            {/* CTA SECTION */}
            <Box
              mt={6}
              p={5}
              borderRadius={4}
              textAlign="center"
              sx={{
                backgroundColor: "#f5f9ff",
                border: "1px solid rgba(25,118,210,0.2)",
              }}
            >
              <Typography
                variant="h5"
                fontWeight={700}
                gutterBottom
              >
                Still have questions?
              </Typography>

              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ mb: 3 }}
              >
                Our team is here to help you get started and
                answer any additional queries you may have.
              </Typography>

              <Button
                variant="contained"
                size="large"
                sx={{
                  borderRadius: 3,
                  textTransform: "none",
                  fontWeight: 600,
                  px: 4,
                  py: 1.5,
                }}
                onClick={() => navigate("/contact")}
              >
                Contact Our Team
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default FaqSection;